var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-card',[_c('div',{staticClass:"viewBtnBox"})]),_c('showForm',{attrs:{"showFormData":_vm.showFormData,"data":_vm.modifyData.obj}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }